import React, { useState, useEffect } from "react";
import { CgClose, CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { BiCheck } from "react-icons/bi";
import { axios } from "../../../../../../../Global";
import { setAppError } from "../../../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import { IoMdClose } from "react-icons/io";

export const ContractCosheetCostplusHeadingEdit = ({
  showPromptElement,
  setShowPromptElement,
  contractDetails,
  setGetUpdatedData,
}) => {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState();
  const [selectedRatecategory, setselectedRatecategory] = useState("1");
  const [selectedDynamicHeading, setSelectedDynamicHeading] = useState("");
  const [dynamicHeadings, setDynamicHeadings] = useState([]);
  const [editHeading, setEditHeading] = useState(false);
  const [editedValue, setEditedValue] = useState("");
  const [showAddNew, SetShowAddNew] = useState(false);
  const [newHeading, setNewHeading] = useState("");
  const [quotationId, setQuotationId] = useState("");
  const [addNewLoading, setAddNewLoading] = useState(false);
  const [deleteLoading, setDeletingLoading] = useState(false);

  useEffect(() => {
    setQuotationId(contractDetails?.contract?.quotation_id);
    const filteredItems = contractDetails?.contract_cost_sheet_headings?.filter(
      (item, index) =>
        item.rate_category_id == selectedRatecategory &&
        item.type === "Dynamic" &&
        item?.rate_category_item_name?.toUpperCase() !==
          "MONTHLY FEE (EACH) (INCLUDING NITAKAT, ADMIN AND SL SERVICE FEE) (SAR)" &&
        item?.rate_category_item_name?.toUpperCase() !== "SALARY"
    );
    setDynamicHeadings(filteredItems);
    setSelectedDynamicHeading("");
    setEditedValue("");
  }, [selectedRatecategory]);

  const onSelectingDynamicHeading = (name) => {
    const filteredItem = dynamicHeadings?.filter(
      (item) => item.rate_category_item_name == name
    )[0];
    const data = {
      heading_name: filteredItem?.rate_category_item_name,
      heading_id: filteredItem?.id,
      rate_category_id: filteredItem?.rate_category_id,
      quotation_id: filteredItem?.quotation_id,
    };
    setSelectedDynamicHeading(data);
    SetShowAddNew(false);
  };

  const onEditHeading = (name) => {
    const editedData = {
      heading_name: name,
      heading_id: selectedDynamicHeading?.heading_id,
      rate_category_id: selectedDynamicHeading?.rate_category_id,
      quotation_id: selectedDynamicHeading?.quotation_id,
    };
    setEditedValue(editedData);
  };

  const submitEditedValues = async () => {
    setLoading(true);
    if (
      selectedDynamicHeading?.heading_name !== editedValue?.heading_name &&
      editedValue?.heading_name != undefined &&
      editedValue?.heading_name != ""
    ) {
      const body = {
        heading_name: editedValue?.heading_name,
        heading_id: editedValue?.heading_id,
        heading_type: "edit",
      };
      try {
        const res = await axios.put(
          `/dashboard/contract-cost-sheet-module-heading-manage/${contractDetails.contract.id}`,
          body,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (res.status === 200) {
          setLoading(false);
          dispatch(
            setAppError({
              msg: res?.data?.message,
              color: "bg-green-600",
            })
          );

          setSelectedDynamicHeading("");
          setEditedValue("");
          setSelectedDynamicHeading("");
          setGetUpdatedData((prev) => !prev);
          setShowPromptElement(false);
        }
      } catch (error) {
        dispatch(setAppError({ msg: error.message }));
        setLoading(false);
      }
    } else {
      setEditedValue("");
      setEditHeading(false);
      setLoading(false);
    }
  };

  const onDeleteHeading = async () => {
    setDeletingLoading(true);
    const body = {
      heading_id: selectedDynamicHeading?.heading_id,
      heading_type: "delete",
    };
    try {
      const res = await axios.put(
        `/dashboard/contract-cost-sheet-module-heading-manage/${contractDetails.contract.id}`,
        body,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.status === 200) {
        setLoading(false);
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "bg-green-600",
          })
        );
        setSelectedDynamicHeading("");
        setEditedValue("");
        setSelectedDynamicHeading("");
        setDeletingLoading(false);
        setGetUpdatedData((prev) => !prev);
        setShowPromptElement(false);
      }
      setDeletingLoading(false);
    } catch (error) {
      dispatch(setAppError({ msg: error.message }));
      setLoading(false);
      setDeletingLoading(false);
    }
  };

  const onAddingNewHeading = (name) => {
    setNewHeading(name);
  };

  const onNewHeadingSubmit = async () => {
    setAddNewLoading(true);
    if (newHeading !== "") {
      const body = {
        heading_name: newHeading,
        rate_category_id: selectedRatecategory,
        heading_type: "add",
      };
      try {
        const res = await axios.put(
          `/dashboard/contract-cost-sheet-module-heading-manage/${contractDetails.contract.id}`,
          body,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (res.status === 200) {
          setLoading(false);
          dispatch(
            setAppError({
              msg: res?.data?.message,
              color: "bg-green-600",
            })
          );
          setAddNewLoading(false);
          setSelectedDynamicHeading("");
          setEditedValue("");
          setSelectedDynamicHeading("");
          setGetUpdatedData((prev) => !prev);
          setShowPromptElement(false);
        }
        setAddNewLoading(false);
      } catch (error) {
        dispatch(setAppError({ msg: error.message }));
        setAddNewLoading(false);
      }
    }
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        showPromptElement ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-xl w-full h-auto    rounded-md bg-white p-5">
        <div className="w-full flex justify-between items-center">
          <h2 className="text-xl  font-bold">EDIT HEADING</h2>
          <button
            className="text-md font-semibold cursor-pointer"
            onClick={() => {
              setShowPromptElement(false);
            }}
          >
            <IoMdClose size={"1.4rem"} />
          </button>
        </div>
        <div className="mt-5  w-10/12 mx-auto">
          {/* dynamic heading */}
          <div className="flex gap-3 justify-center items-end mt-2 mb-8">
            {dynamicHeadings?.length != 0 && (
              <div className="mb-1">
                <label
                  className="block capitalize text-sm mb-1 text-center  font-semibold"
                  htmlFor=""
                >
                  CHOOSE HEADING
                </label>
                <select
                  onChange={(e) => onSelectingDynamicHeading(e.target.value)}
                  className="select select-sm w-10/12 uppercase select-bordered"
                  name="ratecategory"
                  required
                  id=""
                >
                  <option value={""} hidden>
                    SELECT HEADING{" "}
                  </option>
                  {dynamicHeadings?.map((item, index) => (
                    <option key={item.id} value={item.rate_category_item_name}>
                      {item.rate_category_item_name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {selectedRatecategory !== "" && (
              <button
                onClick={() => {
                  SetShowAddNew(true);
                  setSelectedDynamicHeading("");
                }}
                className=" py-2 px-2 w-8/12 text-sm rounded-md ring-1  ring-red text-white text-center bg-red"
              >
                ADD NEW HEADING
              </button>
            )}
          </div>
          {/* selected input edit delete */}
          {dynamicHeadings?.length != 0 &&
            selectedDynamicHeading !== "" &&
            !showAddNew && (
              <div className="flex justify-center items-end gap-3">
                <div className="flex flex-col items-center">
                  <label className=" block uppercase text-sm mb-1  font-semibold">
                    Selected Heading
                  </label>
                  <input
                    disabled={!editHeading}
                    className="input font-semibold input-sm input-bordered"
                    onChange={(e) =>
                      onEditHeading(e.target.value.toUpperCase())
                    }
                    defaultValue={selectedDynamicHeading?.heading_name}
                    placeholder="Edit Heading"
                    value={
                      editedValue == ""
                        ? selectedDynamicHeading?.heading_name
                        : editedValue?.heading_name
                    }
                    required
                    type="text"
                  />
                </div>
                <div className="flex items-center gap-2">
                  {!editHeading ? (
                    <button
                      className="p-1 px-2 text-center rounded-md ring-1 ring-slate-600"
                      onClick={() => {
                        setEditHeading(true);
                      }}
                    >
                      <CiEdit size={"1.4rem"} />
                    </button>
                  ) : (
                    <>
                      <button
                        onClick={() => submitEditedValues()}
                        className="p-1 px-2 text-center rounded-md ring-1 ring-slate-600"
                      >
                        {loading ? (
                          <CgSpinner className="animate-spin mx-auto" />
                        ) : (
                          <BiCheck className="text-xl" />
                        )}
                      </button>
                      <button
                        className="p-1 px-2 text-center rounded-md ring-1 ring-slate-600"
                        onClick={() => {
                          setEditedValue("");
                          setEditHeading(false);
                        }}
                      >
                        <CgClose size={"1.2rem"} />
                      </button>
                    </>
                  )}
                  <button
                    disabled={editHeading}
                    className={
                      editHeading
                        ? "opacity-50 p-1 px-2  rounded-md ring-1 ring-red text-white text-center bg-red"
                        : " p-1 px-2  rounded-md ring-1 ring-red text-white text-center bg-red"
                    }
                    onClick={() => onDeleteHeading()}
                  >
                    {deleteLoading ? (
                      <CgSpinner className="animate-spin mx-auto" />
                    ) : (
                      <MdDeleteOutline size={"1.4rem"} />
                    )}
                  </button>
                </div>
              </div>
            )}
          {showAddNew && (
            <div className="flex items-end gap-3 justify-center">
              <div>
                <input
                  className="input font-semibold input-sm input-bordered"
                  onChange={(e) =>
                    onAddingNewHeading(e.target.value.toUpperCase())
                  }
                  defaultValue={newHeading}
                  placeholder="ENTER NEW HEADING"
                  type="text"
                  required
                />
              </div>
              <div className="flex items-center gap-2">
                <button
                  disabled={newHeading == "" ? true : false}
                  onClick={() => onNewHeadingSubmit()}
                  className={
                    newHeading == ""
                      ? "p-1 opacity-50 px-2 text-center rounded-md ring-1 ring-slate-600"
                      : "p-1  px-2 text-center rounded-md ring-1 ring-slate-600"
                  }
                >
                  {addNewLoading ? (
                    <CgSpinner className="animate-spin mx-auto" />
                  ) : (
                    <BiCheck className="text-xl" />
                  )}
                </button>
                <button
                  className="p-1 px-2 text-center rounded-md ring-1 ring-slate-600"
                  onClick={() => {
                    SetShowAddNew(false);
                    setNewHeading("");
                  }}
                >
                  <CgClose size={"1.2rem"} />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
